<template>
	<div class="w-100 pr-3 pl-3 pt-5 pb-5 bg-white border-15 h-center">
		<div class="w-100 overflow-hidden">
		<div class="overflow-hidden">
			<b>
				ساخت تیکت جدید
			</b>
			<router-link to="/ticket/list">
				<btn
					class="float-left"
					textClass=""
					text="بازگشت به تیکت ها"
					v-if="windowWidth>1000"
				/>
				<btn
					class="float-left"
					textClass=""
					text=">"
					v-else
				/>
			</router-link>
		</div>
		<div class="row">
			<div class="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-4">
				<selectInput 
					:value="val.field"
					label="دپارتمان گیرنده تیکت"
					flds_first="دپارتمان خود را انتخاب کنید"
					:flds="field"
					@inputTxtFunc="(e)=>{val.field = e}"
				/>
			</div>
			<div class="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-4">
				<textInput 
					label="موضوع تیکت"
					:val="val.subject"
					@inputTxtFunc="(e)=>{val.subject = e}"
				 />
			</div>
			<div class="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-4">
				<selectInput 
				:value="val.importance"
				@inputTxtFunc="(e)=>{val.importance = e}"
				label="درجه اهمیت تیکت"
				flds_first= "درجه اهمیت تیکت خود را انتخاب کنید"
				:flds="importances"
				/>
			</div>
			<div class="col-12">
				<textareaInput 
				:value="val.message"
				@inputTxtFunc="(e)=>{val.message = e}"
				label="پیام شما"
				placeholder="پیام خود را در به صورت کامل در این قسمت بنویسید."
				/>
			</div>
			<div class="col-12" style="padding-top: 1rem;">
				<div class="w-100 d-flex align-items-center justify-content-between">
					<label class="mb-2">
						ضمیمه فایل (اختیاری)
					</label>
				</div>
				<file_cloud_lg
				:error="false"
				:files="val.files"
				@chengeFile="(e) => { uploadTF(e)  }"
				@removeFile="(e) => { log('removeFile',e) }"
				label="بارگذاری فایل ها"
				label_sm="حداکثر حجم مجاز : 30 مگابایت"
				/>
			</div>
			<div class="col-12" style="padding-top: 1rem;">
				<btn
					class="w-100"
					textClass="w-100"
					text="ذخیره"
					@clickMe="sav()"
					:disable = "(val.subject<0 || val.field<0 || val.importance<0 || val.message=='')"
					disableText="اطلاعات را تکمیل نمایید"
				/>
			</div>
			<div class="col-12" style="">
				<hr>
				<p style="color:#676767; size: 14px;">
					<img :src="require('../../assets/img/c_1.svg')" width="16" />
					ابتدا موضوع تیکت را انتخاب نموده و مشکل خود را به صورت کامل شرح دهید.
				</p>
				<p style="color:#676767; size: 14px;">
					<img :src="require('../../assets/img/c_2.svg')" width="16" />
					احتمال دارد که کارشناسان ما برای بررسی تیکت‌ از شما سوالی داشته باشند که در جزییات همان تیکت، سوال از شما پرسیده می‌شود.
				</p>
				<p style="color:#676767; size: 14px;">
					<img :src="require('../../assets/img/c_3.svg')" width="16" />
					در نهایت پاسخ شما بررسی شده و به تیکت‌ شما در اسرع وقت پاسخ داده می‌شود.
				</p>
			</div>
		</div>
		</div>
	</div>
</div>
</template>

<script>
	import btn from  "../../UI/button/btn.vue";
	import textareaInput from  "../../UI/input/textareaInput.vue";
	import textInput from  "../../UI/input/textInput.vue";
	import selectInput from  "../../UI/input/selectInput.vue";
	import file_cloud_lg from  "../../UI/uploadFile/file_cloud_lg.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";
	import * as subjects_teacher_json from  "../ticket_list/subjects_teacher.json";
	import * as subjects_user_json from  "../ticket_list/subjects_user.json";
	import * as importances_json from  "../ticket_list/importances.json";


	export default {
		name: 'ticket_create_part1',
		data(){
			return {
				field: [],
				loading: loading,
				success_sm: success_sm,
				success: success,
				error: error,
				val : {
					'subject': '',
					'importance': '-1',
					'field': '-1',
					'message': '',
					'files': [],
				},
				subjects: (this.$localStorage.get('user').username.role==1) ? subjects_user_json.default : subjects_teacher_json.default,
				importances: importances_json.default
			}
		},
		components: {
			btn,
			textInput,
			selectInput,
			textareaInput,
			file_cloud_lg,
		},
		props: {
		},
		mounted(THIS = this){
			window.$.get(window.baseurl+'field/list', {}, function(D){
				if(D.status.code == 401){
					THIS.$localStorage.remove('user');
					THIS.$router.replace('/oneTimePassword');
				}else{
					THIS.field = D.data; 
				}
			}, "json");
		},
		methods:{
			sav(THIS = this){
				var value = this.val;
				value.importance = this.importances[this.val.importance-1].name;
				window.$.post(window.baseurl+'ticket/create', {
					val: value, 
					token: this.$localStorage.get("user")
				}, function(D){
					if(D.ok){
						THIS.success(THIS);
						THIS.$router.push('/ticket/list');
					}else{
						THIS.error(THIS, "ثبت نشد")
					}
				}, "json");
			},
		//***************************************************
		uploadTF(e, THIS = this) {
			THIS.loading(THIS)
			var format =  ["jpg", "jpeg", "png", "pdf", "mp4"];
			var idImg =  "t_[DATE]_[RANDOM]";
			var formData = new FormData();
			formData.append("file", e);
			formData.append("format",format);
			formData.append("idImg", idImg);
			var xhttp = new XMLHttpRequest();
			xhttp.open("POST", window.upldurl, true);
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					THIS.success_sm(THIS)
					this.getVar = JSON.parse(this.responseText);
					var file = {"fileName": this.getVar.filename, "fileUpload": this.getVar.uploadFileName};
					THIS.val.files.push(file);
				}
			};
			xhttp.send(formData);
		},
		}
	}
</script>
